<template>
<div v-if="LoginDisable" >
  <!-- <LoginVue  @forgot="Forgotpassword= true" @cancel="Forgotpassword= false" @loginview="loginviewDisable" ref="delete" :error="Tester"/> -->
  <LoginVueV2 @forgot="Forgotpassword= true" @cancel="Forgotpassword= false" @loginview="loginviewDisable" ref="delete" />
</div>

<div v-if="Test" class="bg-[#e6e6e6] h-[100vh]">

  <div class=" col-span-1 papsi-container bg-[#e6e6e6] flex  h-100vh w-full">
    <div @click="ShowSidebarMobile =!ShowSidebarMobile, ShowSidebar = false" class="w-full h-[100%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]" v-show="ShowSidebarMobile">
    </div>
    <div class="flex fixed z-">
      <div class="w-[350px] shadow-xl border-[#cfcfcf] h-full border-r bg-[#016B00] max-lg:hidden relative" v-show="ShowSidebar">
        <img src="./assets/Sidebar_bg.jpg" class="absolute opacity-10 h-full z-0 w-full">
        <SideBar @showLoader="showLoader()" @hideLoader="hideLoader()" />
    </div>
    </div>
   
    <div class="w-[350px] shadow-xl border-[#cfcfcf] h-full border-r fixed bg-[#016B00] lg:hidden z-50" v-show="ShowSidebarMobile">
      <img src="./assets/Sidebar_bg.jpg" class="absolute opacity-10 h-full z-0 w-full">
      <SideBar />
    </div>

    <div  :class="{'ml-[350px]': ShowSidebar == true }" class="w-full flex flex-col justify-between bg-[#DCDDDC] col-span-1 ">
      <div class=" fixed top-0 bg-[#DCDDDC]  border-[#c7c7c7] w-full">
        <div :class="{'routerView': ShowSidebar === true}" class="flex items-center h-[80px] drop-shadow-md tester  px-[3%] ">
          <div class=" w-full flex items-center ">
            <div class="w-[40px] h-[40px] bg-[#ffffff] p-2 rounded-full  border shadow flex justify-center z-30 max-lg:hidden">
                <MenuButton @click="ShowSidebar =!ShowSidebar"/>
              </div>
              <div class="w-[40px] h-[40px] bg-[#ffffff] p-2 rounded-full  border shadow flex justify-center z-30 lg:hidden">
                <MenuButton @click="ShowSidebarMobile =!ShowSidebarMobile"/>
              </div>
          </div>
          <div class="flex  justify-end"> 
            <NavBar  @changePass="changePass = true" @accountButtonClose="accountButtonview = false" :accountButton="accountButtonview" @accountButton="accountButton" @notificationButtonClose="notificationButtonClose" @notificationButton="navbarActive" :notificationButton="navbarOpen" @logout="logout"/>
          </div>
        </div>
    </div>
    <div class="p-8 h-full px-[4%]  bg-[#e6e6e6] mt-[80px]">
      <div>
        <router-view @showLoader="showLoader" @hideLoader="hideLoader"/>
      </div>
    </div>
  </div>
</div>
</div>
<Loading v-if="loading"/>

<div v-show="Forgotpassword">
  <ForgotPassword ref="forgot" @cancel="Forgotpassword= false, error = '' " @search="search" :error="error" :verifyUsername="true"/>
</div>
<div v-show="ChangePassword">
  <ForgotPassword  ref="forgot" @cancel="ChangePassword= false " @search="search" :error="error" :email="email" :ForgotPassword="true"   @changePassword="changePassword" @resendOtp="resendOtp"  />
</div>

<div v-if="passwordChange">
  <Prompt @CloseSignatory="passwordChange=false" type="PASSWORDCHANGED"/>
</div>

<div v-if="invalidPassword">
  <Prompt @CloseSignatory="invalidPassword=false" type="INVPASS"/>
</div>

<div v-if="changePass">
  <ChangePassword @cancel="changePass = false"  @createNewPassword="createNewPassword" @validPassword="validPassword"/>
</div>

<div v-if="validationpass">
  <Prompt @CloseSignatory="validationpass=false" type="WRONGCPASS"/>
</div>

<div v-if="Empty">
  <Prompt @CloseSignatory="Empty=false" type="EMPTY"/>
</div>

<div v-if="PromptEnabled">
  <Prompt @CloseSignatory="PromptEnabled=false" :type="PromptType"/>
</div>


</template>

<script>
import LoginVueV2 from './components/controls/LoginV2view.vue'
import Loading from './components/controls/Loading/LoadingControl.vue'
import Services from './services/admin'
import SideBar from './components/section/NavSidebarSection.vue'
import NavBar from './components/section/NavBarSection.vue'
import MenuButton from './components/controls/Button/MenuButtonControl.vue'
// import LoginVue from './components/controls/LoginView.vue'
import ChangePassword from './components/controls/modal/ChangePasswordModal.vue'
import Prompt from './components/controls/Prompt/RequestPromt.vue'
import ForgotPassword from './components/controls/modal/ForgotPasswordModal.vue'

import { defineComponent } from 'vue';

export default defineComponent({
  components:{
    SideBar,
    NavBar,
    MenuButton,
    // LoginVue,
    Loading,
    ForgotPassword,
    Prompt,
    LoginVueV2,
    ChangePassword,
    
  },
  data(){
    return{
      PromptType: null,
      PromptEnabled:false,
      Empty:false,
       invalidPassword:    false,
       validationpass:    false,
       changePass:        false,
       passwordChange:    false,
       username:          '',
       email:             '',
       ShowSidebar:   true,
       Test:          false,
       LoginDisable:  true,
       Tester:        '',
       success:       '',
       loading:       false,
       hash:           '',
       Forgotpassword:    false,
       ChangePassword:    false,
       error:             '',
       qweqwe:            '',
       navbarOpen:        false,
       accountButtonview: false,
       otp:'',
       ShowSidebarMobile: false,
       screenWidth: window.innerWidth,
    }
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResolutionChange);
  },
  mounted(){
    window.addEventListener('resize', this.handleResolutionChange);
    this.checklogin()
    this.getProvince()

  },
  methods:{
    async getProvince(){
      const success = await Services.getProvince()
      this.$store.state.region = success
    },
    handleResolutionChange(){
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      if( this.screenWidth < 1024){
        this.ShowSidebar = false
      }
    },
    validPassword(){
      this.PromptType    = "PASSNOTVALID"
      this.PromptEnabled = true
    },
    accountButton(){
      if(this.accountButtonview != true){
          this.accountButtonview = true
      }
      else{
          this.accountButtonview = false
      }
    },
    test(){
      if(!this.ShowSidebar){
        this.ShowSidebar      = false
      }
      else{
        this.ShowSidebar      = true
      }
    },
    clearText(){
      this.$refs.delete.ClearText()
    },
    showLoader(){
      this.loading            = true
    },
    hideLoader(){
      this.loading            = false
    },
    logout(){
      this.showLoader ()
      this.$cookies.remove("hash");
      this.accountButtonview = false
      this.LoginDisable     = true
      this.Test             = false
      this.hideLoader()
    },
    async checklogin(){
      this.showLoader()
      if(!this.$cookies.get('hash')){
        this.$cookies.remove("hash");
        this.hideLoader()
        return
      }
      let state         = this.$store.state
      const success     = await Services.verifyAccount(this.$cookies.get('hash'));
      if(success.success === true){
        this.getEmployeeData()
        this.getDivisionList()
        this.LoginDisable     = false
        this.Test             = true
        this.hash             = success.data.hash
        this.LoginDisable     = false
        this.Test             = true
        this.$cookies.set('hash',this.hash)
        state.full_name       = success.data.full_name
        state.hash            = this.hash
        state.employee_key    = success.data.employee_key
      }
      else if(success.success === false){
        this.LoginDisable     = true
        this.Test             = false
      }
      this.hideLoader()
    },
    async loginviewDisable(user,pass) {
      let that = this
      if(user.user == "" || pass.pass == ""){
        this.Empty = true
        return
      }
      this.showLoader()
      let state               = this.$store.state
      const success           = await Services.login(user, pass);
      this.Tester             = success.message // Handle successful login
      let login               = success.success  
      if(login === true){
        that.$router.push('/');
        this.getEmployeeData()
        this.hash               = success.data.hash
        this.LoginDisable       = false
        this.Test               = true
        state.full_name         = success.data.full_name
        state.hash              = this.hash
        state.employee_key      = success.data.employee_key
        this.getDivisionList()
        this.$cookies.set('hash',this.hash)
      }
      else{
        this.invalidPassword = true
        this.clearText();
      }
      this.hideLoader()
    },
    async getDivisionList(){
      let state         = this.$store.state
      const success = await Services.getDivision()
      state.divisionList = success.data
    },
    async search(username){
      this.showLoader()
      const success = await Services.verifyUsername(username);
      this.error = success.message
      if(success.success === true){
        this.ChangePassword = true
        this.$refs.forgot.startTimer()
        this.Forgotpassword = false
        this.username = username
        this.email =  success.data.email
        this.otp = Math.floor(Math.random() * 999999);
        await Services.sendOTP(this.email, this.otp,username);

      }
      this.hideLoader()
    },
    async resendOtp(){
      this.showLoader()
      this.otp = Math.floor(Math.random() * 999999);
      await Services.sendOTP(this.email, this.otp,this.username);
      this.$refs.forgot.startTimer()
      this.hideLoader()
    },
    async changePassword(otp,password){
      this.showLoader()
      if(otp != this.otp){
        this.error = "INVALID OTP"
      }
      else{
        this.ChangePassword = false
        await Services.forgotPasswordChange(this.username,password)
        this.passwordChange = true
      }
      this.hideLoader()
    },
    async getEmployeeData(){
      let state = this.$store.state
      const success = await Services.getEmployeeInfo()
      state.emp_info = success.data
    },
    async createNewPassword(cPassword,nPassword,conPassword){
      if(nPassword != conPassword){
        this.PromptType    = "NEWPASSWORD"
        this.PromptEnabled = true        
        return
      }
      else{
        this.showLoader()
        let state          = this.$store.state
        const success      = await Services.changePassword(state.employee_key,cPassword,nPassword);
        if(success.success == true){
          this.changePass      = false
          this.passwordChange  = true
        }
        else{
          if(success.message == "previous password cannot be the same as the current password."){
            this.PromptType    = "SAMEPASS"
            this.PromptEnabled = true
          }
          else{
            this.validationpass  = true
          }
        }
        this.hideLoader()
      }
    },
    navbarActive(){
      this.navbarOpen = true
    },
    notificationButtonClose(){
      this.navbarOpen = false
    },
  }
})


</script>

<style scoped>
  img {
    pointer-events: none;
  } 

.shadow{
    box-shadow: rgba(6, 24, 44, 0.048) 0px 0px 0px 2px, rgba(6, 24, 44, 0.493) 0px 4px 6px -1px, rgba(255, 255, 255, 0.24) 0px 1px 0px inset;
 }

.routerView{

  width: calc(100% - 350px);
}

</style>